/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'

import { BusinessAccountFeature, BusinessAccountFragment } from '~/gql/graphql'

import { BusinessAccountUI, BusinessAccountMember } from './types'

interface AdminBusinessAccountContext {
    isBusinessAdmin: boolean
    ui: BusinessAccountUI
    member: BusinessAccountMember
    businessAccount: BusinessAccountFragment
    toggleUi: (key: string) => void
    refetch: () => void
    setMember: (member: BusinessAccountMember) => void
    setBusinessAccount: (businessAccount: BusinessAccountFragment) => void
}

export const defaultState: AdminBusinessAccountContext = {
    isBusinessAdmin: false,
    ui: {},
    member: {} as BusinessAccountMember,
    businessAccount: {
        __typename: 'BusinessAccount',
        id: '',
        name: '',
        isEnabled: false,
        enabledAt: '',
        createdAt: '',
        totalMembers: 0,
        totalTeams: 0,
        isTeamsFeatureEnabled: false,
        // Need to work out new codegen marking optional properties as required
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        salesforceAccount: {
            __typename: 'SalesforceAccount',
            url: '',
        },
        subscription: null,
        excludedCountries: [],
    },
    toggleUi: () => {},
    refetch: () => {},
    setMember: () => {},
    setBusinessAccount: () => {},
}

export const AdminBusinessAccountContext =
    createContext<AdminBusinessAccountContext>(defaultState)

export const BusinessAccountFinanceFeaturesContext = createContext<{
    businessAccountFeatures: BusinessAccountFeature[]
    hasAssignFinanceCapabilities: boolean
}>({
    businessAccountFeatures: [],
    hasAssignFinanceCapabilities: false,
})
